import React from "react";
import Image from "react-bootstrap/Image";

function CateringMenu() {
  return (
    <>
      <div className="col-12 pb-2">
        <Image src="img/OFCATERING1.webp" fluid />
        <Image src="img/OFCATERING2.webp" fluid />
        <Image src="img/OFCATERING3.webp" fluid />
        <Image src="img/OFCATERING4.webp" fluid />
        <Image src="img/OFCATERING5.webp" fluid />
      </div>
    </>
  );
}

export default CateringMenu;
